/* eslint-disable ember/no-classic-components */

import { MODE_APPOINTMENT } from 'client-portal/utils/prescreener/constants';
import { computed } from '@ember/object';
import { reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
/* eslint-disable-next-line */
import classic from 'ember-classic-decorator';

@classic
export default class RequestInformationClientBase extends Component {
  @service currentPractice;
  @service session;
  @service media;
  @service prescreener;

  get modeAppointment() {
    return MODE_APPOINTMENT;
  }

  @reads('client._isDirty') isDirty;
  @reads('currentPractice.featureEnableClientPortalPrescreenerSettings')
  featureEnableClientPortalPrescreenerSettings;
  @reads('currentPractice.showPaymentSelection') showPaymentSelection;

  @computed(
    'session.{isMonarchEmbedded,isClientPortalMonarchOrSpWebsite}',
    'featureEnableClientPortalPrescreenerSettings',
    'showPaymentSelection'
  )
  get canDisplayPaymentOption() {
    let { session, featureEnableClientPortalPrescreenerSettings, showPaymentSelection } = this;

    let { isMonarchEmbedded, isClientPortalMonarchOrSpWebsite } = session;

    let isPaymentMethodAvailable = isClientPortalMonarchOrSpWebsite || isMonarchEmbedded;

    if (featureEnableClientPortalPrescreenerSettings) {
      return showPaymentSelection && isPaymentMethodAvailable;
    }

    return isPaymentMethodAvailable;
  }

  get isDesktopFeatureEnabled() {
    return !this.media.isXsDown;
  }

  get dropdownPrimaryInstructions() {
    return this.isDesktopFeatureEnabled ? 'Choose file' : 'Upload a file';
  }

  get dropdownSecondaryInstructions() {
    return this.isDesktopFeatureEnabled ? ' or drag and drop file' : ' or take a picture';
  }

  get fieldClass() {
    return this.isDesktopFeatureEnabled ? 'col-lg-12' : 'col-lg-6';
  }

  get isPrescreenerEnabled() {
    return this.prescreener.isPrescreenerEnabled;
  }

  get useLegacyPrescreener() {
    return !this.usePrescreenerForms;
  }

  get usePrescreenerForms() {
    return this.prescreener.preview.isPreview || this.isPrescreenerEnabled;
  }
}
/* eslint-enable ember/no-classic-components */
